/**
 * <faq-list> wraps a set of accordion FAQ rows and reveals rows beyond the
 * initial `data-show-count` when its "Show more" button is clicked, without
 * a page reload. All rows are present in the DOM from render (so the
 * FAQPage JSON-LD content and hidden rows stay crawlable); only visibility
 * toggles client-side.
 */
class FaqList extends HTMLElement {
  connectedCallback() {
    this.toggle = this.parentElement?.querySelector('[data-faq-show-more]');
    if (!this.toggle) return;

    this.toggle.addEventListener('click', this.#onToggleClick);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.#onToggleClick);
  }

  #onToggleClick = () => {
    const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
    const hiddenItems = this.querySelectorAll('.collection-faq-item[hidden]');
    const labelMore = this.toggle.querySelector('[data-label-more]');
    const labelLess = this.toggle.querySelector('[data-label-less]');

    if (expanded) {
      const showCount = Number(this.dataset.showCount) || 5;
      const items = this.querySelectorAll('.collection-faq-item');
      items.forEach((item, index) => {
        if (index >= showCount) item.hidden = true;
      });
      this.toggle.setAttribute('aria-expanded', 'false');
      labelMore?.removeAttribute('hidden');
      labelLess?.setAttribute('hidden', '');
      this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } else {
      hiddenItems.forEach((item) => {
        item.hidden = false;
      });
      this.toggle.setAttribute('aria-expanded', 'true');
      labelMore?.setAttribute('hidden', '');
      labelLess?.removeAttribute('hidden');
    }
  };
}

if (!customElements.get('faq-list')) {
  customElements.define('faq-list', FaqList);
}
